module.exports = __webpack_public_path__ + "img/sec1_box7.54fe8ad2.jpg";